// src/lazyLoad.ts
import { create } from "zustand";
var lazyLoadStore = (loadData) => {
  const store = create((set, get) => ({
    data: void 0,
    load: async () => {
      if (!get().data) {
        set({ data: await loadData() });
      }
    }
  }));
  const caller = () => {
    const s = store();
    s.load();
    return s.data;
  };
  caller.getState = async () => {
    await store.getState().load();
    return store.getState().data;
  };
  return caller;
};
var lazyLoad = async (lazyImport) => {
  const module = await lazyImport();
  return module.default;
};
export {
  lazyLoad,
  lazyLoadStore
};
